interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
}

/**
 * Replaces ion-toggle. A real checkbox underneath, so it is keyboard operable
 * and announced as a switch; the visual is drawn from the `checked` prop
 * rather than peer-* variants, because the knob is a descendant of the track
 * and peer-* only reaches siblings.
 */
export function Toggle({ checked, onChange, label, disabled }: ToggleProps) {
  return (
    <label className="inline-flex shrink-0 cursor-pointer items-center">
      <input
        type="checkbox"
        role="switch"
        className="peer sr-only"
        checked={checked}
        disabled={disabled}
        aria-label={label}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span
        className={[
          'relative h-6 w-11 rounded-full transition-colors',
          'peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-accent',
          checked ? 'bg-primary' : 'bg-slate-300',
          disabled ? 'opacity-50' : '',
        ].join(' ')}
      >
        <span
          className={[
            'absolute top-0.5 left-0.5 size-5 rounded-full bg-white shadow transition-transform',
            checked ? 'translate-x-5' : 'translate-x-0',
          ].join(' ')}
        />
      </span>
    </label>
  );
}
